import React, { memo } from "react";
import { Label, DatePickerComponent } from "../";

const DateRangePicker = ({
  values,
  setFieldValue,
  className = "col-lg-2 col-md-6 col-12",
  startMinDate = new Date(),
  customClass = "",
}) => {
  return (
    <>
      {/* <div className="row m-0 p-0"> */}
      <div className={customClass}>
        <div className="date-input-box">
          <Label htmlFor="startDate" className="lead_text">
            Start Date
          </Label>
          <DatePickerComponent
            selectedDate={values.startDate}
            onChange={(date) => {
              setFieldValue("startDate", date);
              // setFieldValue("endDate", null);
            }}
            placeholderText="Pick a start date"
            // minDate={startMinDate}
            isClearable={false}
            className="form-control w-100"
            dateFormat="dd-MM-yyyy"
          />
        </div>
      </div>
      <div className={customClass}>
        <div className="date-input-box">
          <Label htmlFor="endDate" className="lead_text">
            End Date
          </Label>
          <DatePickerComponent
            selectedDate={values.endDate}
            onChange={(date) => setFieldValue("endDate", date)}
            placeholderText="Pick an end date"
            minDate={values.startDate}
            isClearable={false}
            className="form-control"
            // disabled={!values.startDate}
            dateFormat="dd-MM-yyyy"
          />
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default memo(DateRangePicker);
